import remainingChars from "surveylabJsAssets/page/_remaining-chars";

export default function () {
    $(function () {
        $('.checkbox-free-element .option-check').on('change', function (this: HTMLInputElement) {
            const checkboxID = $(this).attr('id');
            const textFieldID = '#' + checkboxID + '_free';

            $(textFieldID).val('');

            if (this.checked) {
                $(textFieldID).trigger('focus');
            }
        });

        // On entering the free text field, select the corresponding checkbox
        $('.checkbox-free-element .free-text').on('focusin', function () {
            const $optionContainer = $(this).closest('.option-container');
            const $checkmark = $optionContainer.find($('.option-check'));
            $checkmark.prop("checked", true);
        });
    });
    remainingChars.initOnce();
}
